<template>

  <button class="btn"
    v-bind="{...$attrs}"
    v-on="{...$listeners}"

    v-shortkey="keys"
    @shortkey="emitClick"
    >
    <slot></slot><template v-if="skey">({{skey}})</template>
  </button>

</template>

<script>
export default {
  inheritAttrs: false,
  props: ['type', 'skey'],
  data() {
    return {
      keys : null,
      canClickEmit : true, // click emit 가능 여부
    }
  },
  created() {
    const keys = this.skey && this.skey.toLowerCase().split("+") || null
    this.keys = keys
  },
  methods: {
    emitClick: _.throttle(function(e) {
      this.$emit('click', e)
    }, 1500, {trailing: false}),
    // emitClick(e) {
    //   console.log('키보드 emit 호출');

    //   if (this.canClickEmit) { // click emit 가능할때만
    //     this.canClickEmit = false // 바로 불가능으로 바꾸고
    //     console.log("실제 emit 호출");

    //     this.$emit('click', e) // emit 실행하고
    //     setTimeout(() => this.canClickEmit = true, 1500) // 2초뒤엔 다시 가능하게
    //   }
    // },
  },
}
</script>
